import { View } from 'foundations-components/components/View';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { EcosystemSlider } from 'trellis-ecosystem';
import { Subscreens } from '../constants/usage';
import { StorefrontListingCard } from './cards/StorefrontListingCard';
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderSection({
  title,
  cards,
  context,
  productType,
  sectionIndex,
  sectionType
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggestion section ${direction} arrow clicked`,
      itemIndex: sectionIndex,
      section: String(sectionType),
      subscreen: Subscreens.SUGGESTION_SECTION,
      type: productType,
      value: context === null || context === void 0 ? void 0 : context.value
    }));
  };
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.SUGGESTION_SECTION,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "slider-section",
      marginBlockEnd: "1000",
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(EcosystemSlider, {
        cardWidth: 306,
        gradientColor: "fill-surface-recessed",
        onScrollButtonClick: trackSliderButtonClicked
        // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
        ,
        scrollButtonTop: "43.5%",
        title: title,
        children: cards.map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
          listing: card,
          context: context,
          resultCount: cards.length,
          resultIndex: index,
          section: String(sectionType)
        }, card.listingId))
      })
    })
  });
}